enum ProductMigrationState {
    Pending = "PENDING",
    InProgress = "IN_PROGRESS",
    Complete = "COMPLETE"
}
export default ProductMigrationState